import {store} from '../store/Store';
import {mdservices} from '../store/MarketData';

export class ChartDatafeed {
  private _earliestDate: Date;
  private _data: any[];
  private _initialChartData: any[];
  private isDebug: boolean;

  constructor(isDebug = false) {
    this._earliestDate = new Date();
    this._data = [];
    this._initialChartData = [];
    this.isDebug = isDebug;
  }


  async loadLatestChartData(
    numberOfExtraBars: number,
    chartInterval: string,
    isRefresh = false
  ): Promise<void> {
    try {
      const initialData = await getChartData( numberOfExtraBars, new Date(), chartInterval,this.isDebug);
      this._initialChartData = initialData;
    } catch (error) {
      console.error('[ChartDatafeed] Failed to load chart data:', error);
    }
  }

  async loadChartDataAsync(
    numberOfExtraBars: number,
    chartInterval: string,
    isRefresh = false
  ): Promise<void> {
    try {
      if (isRefresh) {
        this._data = [];
        this._earliestDate = new Date();
        if (this.isDebug) console.log('[ChartDatafeed] Refreshing chart data.');
      }

      const historicalData = await getChartData(
        numberOfExtraBars,
        this._earliestDate,
        chartInterval,
        this.isDebug
      );

      if (historicalData.length > 0) {
        // Prepend to _data for scroll case
        this._data = [...historicalData, ...this._data];
        this._earliestDate = new Date(historicalData[0].DT);
        if (this.isDebug)
          console.log('[ChartDatafeed] New earliestDate set to:', this._earliestDate);
      }
    } catch (error) {
      console.error('[ChartDatafeed] Failed to load chart data:', error);
    }
  }

  getLastChartData(): any[] {
    return this._data;
  }

  getLatestChartData(): any[] {
    return this._initialChartData;
  }
}

function getChartData(
  numberOfPoints = 250,
  endDate: Date = new Date(),
  chartInterval: string,
  isDebug = false
): Promise<any[]> {
  return new Promise((resolve, reject) => {
    const intervalToSeconds = (interval: string): number => {
      const unit = interval.slice(-1);
      const value = parseInt(interval.slice(0, -1), 10);
      switch (unit?.toLowerCase()) {
        case 'm': return value * 60;
        case 'h': return value * 3600;
        case 'd': return value * 86400;
        case 'w': return value * 604800;
        default: throw new Error(`Unsupported interval format: ${interval}`);
      }
    };

    let intervalInSeconds: number;
    try {
      intervalInSeconds = intervalToSeconds(chartInterval);
    } catch (err) {
      console.error('[getChartData] Invalid interval:', chartInterval);
      reject(err);
      return;
    }

    const startDate = new Date(endDate.getTime() - numberOfPoints * intervalInSeconds * 1000);
    const adjustedStartDate = new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000);

    const startUnix = Math.floor(adjustedStartDate.getTime());
    const endUnix = Math.floor(endDate.getTime());

    if (isDebug) {
      console.log(
        '[getChartData] Fetching chart data from',
        adjustedStartDate,
        'to',
        endDate,
        'Interval:',
        chartInterval
      );
      console.log('[getChartData] Unix Range:', startUnix, '→', endUnix);
    }

    if (Number.isNaN(startUnix) || Number.isNaN(endUnix)) {
      console.error('[getChartData] Invalid timestamps:', startUnix, endUnix);
      reject(new Error('Invalid start or end Unix timestamp'));
      return;
    }

    mdservices.fetchChartPaginationData(
      [store.frontToken, store.backToken],
      chartInterval,
      startUnix,
      endUnix,
      (data) => {
        if (!data || data.length === 0) {
          if (isDebug)
            console.warn(
              '[getChartData] No data returned for range:',
              new Date(startUnix),
              '→',
              new Date(endUnix)
            );
          resolve([]);
          return;
        }

        if (isDebug) {
          console.log(
            '[getChartData] Chart data fetched: from',
            new Date(data[0].DT),
            'to',
            new Date(data[data.length - 1].DT)
          );
        }

        resolve(data);
      },
      (error) => {
        console.error('[getChartData] Error fetching chart data:', error);
        reject(error);
      }
    );
  });
}
